<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { getStoredLocale } from "@/utils/locale";

/**
 * About page component
 */
export default {
  page() {
    return {
      title: this.$t("about.text"),
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "About",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "About",
          active: true,
        },
      ],
      ismobile: false,
      activeNames: [],
      activeapp: [],
      updatelog: [],
      lang: "",
      buildTime: process.env.VUE_APP_BUILD_TIME || "",
      systemInfo: {
        cpu: null,
        cpu_load1: null,
        cpu_status: null,
        memory: null,
        memory_status: null,
        storage: null,
        storage_status: null,
        storage_used: null,
        storage_total: null,
        uptime: null,
        hostname: "",
        model: "",
        version: ""
      },
      platformStats: {
        deviceCount: 0,
        userCount: 0,
        anonymousUsers: 0,
        remainingDays: 0
      },
      loading: {
        systemInfo: false,
        platformStats: false,
        versionStatus: false,
        storage: false
      },
      clearing: "",
      programVersionStatus: [],
      allowPreview: false,
      canTogglePreview: 0,
      previewSupported: false,
      previewSaving: false,
      storageUsage: {
        can_clear: 0,
        logs: { bytes: 0, files: 0, human: "0 B", items: [] },
        cache: { bytes: 0, files: 0, human: "0 B", items: [] }
      },
      companyInfo: {
        name: "AICOIOT",
        founded: "2020",
        employees: "50+",
        locations: "3"
      },
      features: [
        {
          icon: "ri-shield-check-line",
          title: "security",
          description: "security_desc"
        },
        {
          icon: "ri-flashlight-line", 
          title: "performance",
          description: "performance_desc"
        },
        {
          icon: "ri-global-line",
          title: "global",
          description: "global_desc"
        },
        {
          icon: "ri-customer-service-line",
          title: "support",
          description: "support_desc"
        }
      ],
      stats: [
        {
          icon: "ri-device-line",
          value: "0",
          label: "device_count"
        },
        {
          icon: "ri-user-line",
          value: "0",
          label: "user_count"
        },
        {
          icon: "ri-user-settings-line",
          value: "0",
          label: "anonymous_users"
        },
        {
          icon: "ri-calendar-line",
          value: "0",
          label: "remaining_days"
        }
      ]
    };
  },
  mounted() {
    this.title = this.$t("about.text");
    this.items = [
      {
        text: this.$t("menuitems.dashboard.text"),
        href: "/",
      },
      {
        text: this.$t("about.text"),
        active: true,
      },
    ];
    this.lang = getStoredLocale();
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    
    this.getSystemInfo();
    this.getPlatformStats();
    this.getProgramVersionStatus();
    this.getStorageUsage();
  },
  methods: {
    getFourDigitVersion(versionValue) {
      const digits = String(versionValue || "").replace(/\D/g, "");
      if (!digits) {
        return "";
      }
      if (digits.length >= 4) {
        return digits.slice(-4);
      }
      return digits.padStart(4, "0");
    },
    getupdatelog(versionValue) {
      var that = this;
      const fourDigitVersion = that.getFourDigitVersion(
        versionValue || that.systemInfo.version || that.version
      );
      if (!fourDigitVersion) {
        that.updatelog = {};
        return;
      }

      that.$axios
        .get(
          "https://update.aicoiot.com/saas/admin/" +
          fourDigitVersion +
            ".json"
        )
        .then(function (response) {
          let update = response.data;
          that.updatelog = update;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getSystemInfo() {
      var that = this;
      that.loading.systemInfo = true;
      
      that.$axios
        .post(
          that.apiuri,
          {
            action: "base_systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading.systemInfo = false;
          if (response.data.status === 200) {
            const data = response.data.data || {};
            that.systemInfo = {
              cpu: that.nullableNumber(data.cpu),
              cpu_load1: that.nullableNumber(data.cpu_load1),
              cpu_status: data.cpu_status || null,
              memory: that.nullableNumber(data.memory),
              memory_status: data.memory_status || null,
              storage: that.nullableNumber(data.storage),
              storage_status: data.storage_status || null,
              storage_used: that.nullableNumber(data.storage_used),
              storage_total: that.nullableNumber(data.storage_total),
              uptime: that.nullableNumber(data.uptime),
              hostname: data.hostname || "",
              model: data.model || "",
              version: data.version || ""
            };
            that.getupdatelog(data.version || that.version);
          } else {
            that.getupdatelog(that.version);
          }
        })
        .catch(function () {
          that.loading.systemInfo = false;
          that.systemInfo = {
            cpu: null,
            cpu_load1: null,
            cpu_status: null,
            memory: null,
            memory_status: null,
            storage: null,
            storage_status: null,
            storage_used: null,
            storage_total: null,
            uptime: null,
            hostname: "",
            model: "",
            version: that.version
          };
          that.getupdatelog(that.version);
        });
    },
    getPlatformStats() {
      var that = this;
      that.loading.platformStats = true;
      
      // 获取设备数量
      that.$axios
        .post(
          that.apiuri,
          {
            action: "deviceslist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status === 200) {
            that.platformStats.deviceCount = response.data.data.length;
            that.stats[0].value = response.data.data.length.toString();
          }
        })
        .catch(function (error) {
          // console.log(error);
        });

      // 获取用户数量
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getuserlist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status === 200) {
            let usercount = response.data.count;
            that.platformStats.userCount = usercount;
            that.stats[1].value = usercount.toString();
          }
        })
        .catch(function (error) {
          // console.log(error);
        });

      // 获取匿名用户数量（通过临时用户列表）
      that.$axios
        .post(
          that.apiuri,
          {
            action: "gettemporaryuserlist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading.platformStats = false;
          if (response.data.status === 200) {
            that.platformStats.anonymousUsers = response.data.count;
            that.stats[2].value = response.data.count.toString();
          }
        })
        .catch(function (error) {
          that.loading.platformStats = false;
          // console.log(error);
        });

      // 计算剩余天数（基于许可证或订阅信息）
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getlicenseinfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status === 200 && response.data.data) {
            const licenseData = response.data.data;
            if (licenseData.expire_date) {
              const diffDays = licenseData.expire_date
              that.platformStats.remainingDays = Math.max(0, diffDays);
              that.stats[3].value = Math.max(0, diffDays).toString();
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          // 如果无法获取许可证信息，使用默认值
          that.platformStats.remainingDays = 365;
          that.stats[3].value = "365";
        });
    },
    compareVersions(localVersion, latestVersion) {
      const normalize = (version) => {
        return String(version || "")
          .trim()
          .replace(/^[vV]/, "")
          .split(".")
          .map((part) => {
            const n = parseInt(part, 10);
            return Number.isNaN(n) ? 0 : n;
          });
      };

      const localParts = normalize(localVersion);
      const latestParts = normalize(latestVersion);
      const maxLen = Math.max(localParts.length, latestParts.length);

      for (let i = 0; i < maxLen; i++) {
        const localPart = localParts[i] || 0;
        const latestPart = latestParts[i] || 0;
        if (localPart < latestPart) return -1;
        if (localPart > latestPart) return 1;
      }
      return 0;
    },
    getProgramDisplayName(programName) {
      if (programName === "saasadmin") return "管理后台";
      if (programName === "cashierpage") return "收银页面";
      if (programName === "tcpserver") return "通信服务器";
      return programName || "-";
    },
    getProgramVersionStatus() {
      const that = this;
      that.loading.versionStatus = true;

      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_program_version_status",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading.versionStatus = false;
          if (response.data.status === 200 && Array.isArray(response.data.data)) {
            that.previewSupported = Object.prototype.hasOwnProperty.call(response.data, "allow_preview");
            that.allowPreview = Number(response.data.allow_preview) === 1;
            that.canTogglePreview = Number(response.data.can_toggle_preview) === 1 ? 1 : 0;
            that.programVersionStatus = response.data.data.map((item) => {
              const localVersion = item.local_version || "";
              const latestVersion = item.latest_version || "";
              const backendFlag = Number(item.has_update) === 1;
              const frontendFlag =
                localVersion && latestVersion
                  ? that.compareVersions(localVersion, latestVersion) < 0
                  : false;
              return {
                ...item,
                local_version: localVersion,
                latest_version: latestVersion,
                latest_channel: item.latest_channel || "stable",
                has_update: backendFlag || frontendFlag,
              };
            });
          } else {
            that.programVersionStatus = [];
          }
        })
        .catch(function () {
          that.loading.versionStatus = false;
          that.programVersionStatus = [];
        });
    },
    channelText(channel) {
      const name = channel === "beta" || channel === "dev" ? channel : "stable";
      const key = "about.program.channel_" + name;
      return this.$te(key) ? this.$t(key) : name;
    },
    toggleAllowPreview(event) {
      const that = this;
      const enabled = !!(event && event.target && event.target.checked);
      if (that.canTogglePreview !== 1) {
        if (event && event.target) {
          event.target.checked = that.allowPreview;
        }
        return;
      }
      that.previewSaving = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "toggle_preview_update",
            enabled: enabled ? 1 : 0,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.previewSaving = false;
          if (response.data.status === 200) {
            that.allowPreview = Number(response.data.enabled) === 1;
            if (that.$message) {
              that.$message.success(that.$t("about.program.preview_saved"));
            }
            that.getProgramVersionStatus();
            return;
          }
          that.allowPreview = !enabled;
          if (event && event.target) {
            event.target.checked = that.allowPreview;
          }
          const forbidden = response.data.status === 403;
          if (that.$message) {
            that.$message.error(that.$t(forbidden ? "about.program.preview_forbidden" : "about.program.preview_failed"));
          }
        })
        .catch(function () {
          that.previewSaving = false;
          that.allowPreview = !enabled;
          if (event && event.target) {
            event.target.checked = that.allowPreview;
          }
          if (that.$message) {
            that.$message.error(that.$t("about.program.preview_failed"));
          }
        });
    },
    formatBuildTime(buildTime) {
      if (!buildTime) {
        return new Date().toLocaleString();
      }

      const parsed = new Date(buildTime);
      if (Number.isNaN(parsed.getTime())) {
        return buildTime;
      }

      return parsed.toLocaleString();
    },
    formatUptime(days) {
      if (days === null || days === undefined || days === "") {
        return this.$t("about.system.unavailable");
      }
      if (days < 1) {
        return this.$t('about.uptime.hours', { hours: Math.floor(days * 24) });
      } else if (days < 30) {
        return this.$t('about.uptime.days', { days: Math.floor(days) });
      } else {
        const months = Math.floor(days / 30);
        const remainingDays = Math.floor(days % 30);
        return this.$t('about.uptime.months', { months, days: remainingDays });
      }
    },
    nullableNumber(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const number = Number(value);
      return Number.isNaN(number) ? null : number;
    },
    formatMetric(value) {
      if (value === null || value === undefined) {
        return this.$t("about.system.unavailable");
      }
      return value + "%";
    },
    metricClass(status) {
      if (status === "ok") return "text-success";
      if (status === "warn") return "text-warning";
      if (status === "critical") return "text-danger";
      return "text-muted";
    },
    statusText(status) {
      if (status === "ok") return this.$t("about.system.status_ok");
      if (status === "warn") return this.$t("about.system.status_warn");
      if (status === "critical") return this.$t("about.system.status_critical");
      return "";
    },
    statusBadgeClass(status) {
      if (status === "ok") return "bg-success";
      if (status === "warn") return "bg-warning text-dark";
      if (status === "critical") return "bg-danger";
      return "bg-secondary";
    },
    runStatusText(status) {
      if (status === "running") return this.$t("about.program.running");
      if (status === "stopped") return this.$t("about.program.stopped");
      if (status === "present") return this.$t("about.program.present");
      return "";
    },
    runStatusBadgeClass(status) {
      if (status === "running") return "bg-success";
      if (status === "stopped") return "bg-danger";
      if (status === "present") return "bg-secondary";
      return "bg-secondary";
    },
    formatBytes(bytes) {
      const value = Number(bytes);
      if (!Number.isFinite(value) || value < 0) {
        return "0 B";
      }
      const units = ["B", "KB", "MB", "GB", "TB"];
      let size = value;
      let index = 0;
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index += 1;
      }
      const digits = index === 0 ? 0 : 2;
      return size.toFixed(digits) + " " + units[index];
    },
    storageItemLabel(key) {
      const translated = this.$t("about.storage." + key);
      if (translated && translated !== "about.storage." + key) {
        return translated;
      }
      return key;
    },
    getStorageUsage() {
      const that = this;
      that.loading.storage = true;
      that.$axios
        .post(
          that.apiuri,
          { action: "get_storage_usage" },
          { headers: { Openid: that.userinfo.openid } }
        )
        .then(function (response) {
          that.loading.storage = false;
          if (response.data.status === 200 && response.data.data) {
            const data = response.data.data;
            that.storageUsage = {
              can_clear: Number(data.can_clear) === 1 ? 1 : 0,
              logs: data.logs || { bytes: 0, files: 0, human: "0 B", items: [] },
              cache: data.cache || { bytes: 0, files: 0, human: "0 B", items: [] }
            };
          }
        })
        .catch(function () {
          that.loading.storage = false;
        });
    },
    clearStorage(target) {
      const that = this;
      const confirmKey = target === "cache"
        ? "about.storage.clear_cache_confirm"
        : "about.storage.clear_logs_confirm";
      that.$confirm(that.$t(confirmKey), that.$t("global.delete.sureyouaction"), {
        confirmButtonText: that.$t("global.button.ok"),
        cancelButtonText: that.$t("global.button.cancel"),
        type: "warning"
      }).then(function () {
        that.clearing = target;
        that.$axios
          .post(
            that.apiuri,
            { action: "clear_storage", target: target },
            { headers: { Openid: that.userinfo.openid } }
          )
          .then(function (response) {
            that.clearing = "";
            if (response.data.status === 200) {
              const deleted = response.data.data ? response.data.data.deleted : 0;
              const size = response.data.data ? response.data.data.freed_human : "0 B";
              that.$message({
                message: that.$t("about.storage.clear_success", { count: deleted, size: size }),
                type: "success"
              });
              that.getStorageUsage();
            } else if (response.data.status === 403) {
              that.$message.error(that.$t("about.storage.clear_forbidden"));
            } else {
              that.$message.error(that.$t("global.errors.operation"));
            }
          })
          .catch(function () {
            that.clearing = "";
            that.$message.error(that.$t("global.errors.network"));
          });
      }).catch(function () {});
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- 统计数据区域 -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-primary text-white">
            <h6 class="mb-0">
              <i class="ri-bar-chart-line me-2"></i>
              {{ $t('about.stats.title') }}
            </h6>
          </div>
          <div class="card-body" v-loading="loading.platformStats">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-12 mb-3" v-for="stat in stats" :key="stat.label">
                <div class="text-center p-3 border rounded">
                  <i :class="[stat.icon, 'text-primary mb-2']" style="font-size: 2rem;"></i>
                  <h4 class="text-primary mb-1">{{ stat.value }}</h4>
                  <small class="text-muted">{{ $t('about.stats.' + stat.label) }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 系统信息和更新日志 -->
    <div class="row">
      <!-- 系统信息 -->
      <div class="col-lg-6 col-12 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-header bg-info text-white">
            <h6 class="mb-0">
              <i class="ri-computer-line me-2"></i>
              {{ $t('about.system.title') }}
            </h6>
          </div>
          <div class="card-body" v-loading="loading.systemInfo || loading.versionStatus">
            <div class="row mb-3">
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-cpu-line mb-2" :class="metricClass(systemInfo.cpu_status)" style="font-size: 2rem;"></i>
                  <h5 class="mb-1" :class="metricClass(systemInfo.cpu_status)">{{ formatMetric(systemInfo.cpu) }}</h5>
                  <small class="text-muted">{{ $t('about.system.cpu') }}</small>
                  <div v-if="statusText(systemInfo.cpu_status)" class="mt-1">
                    <span class="badge" :class="statusBadgeClass(systemInfo.cpu_status)">{{ statusText(systemInfo.cpu_status) }}</span>
                  </div>
                  <small v-if="systemInfo.cpu_load1 !== null" class="text-muted d-block mt-1">
                    {{ $t('about.system.load1', { value: systemInfo.cpu_load1 }) }}
                  </small>
                </div>
              </div>
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-database-2-line mb-2" :class="metricClass(systemInfo.memory_status)" style="font-size: 2rem;"></i>
                  <h5 class="mb-1" :class="metricClass(systemInfo.memory_status)">{{ formatMetric(systemInfo.memory) }}</h5>
                  <small class="text-muted">{{ $t('about.system.memory') }}</small>
                  <div v-if="statusText(systemInfo.memory_status)" class="mt-1">
                    <span class="badge" :class="statusBadgeClass(systemInfo.memory_status)">{{ statusText(systemInfo.memory_status) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-hard-drive-line mb-2" :class="metricClass(systemInfo.storage_status)" style="font-size: 2rem;"></i>
                  <h5 class="mb-1" :class="metricClass(systemInfo.storage_status)">{{ formatMetric(systemInfo.storage) }}</h5>
                  <small class="text-muted">{{ $t('about.system.storage') }}</small>
                  <div v-if="statusText(systemInfo.storage_status)" class="mt-1">
                    <span class="badge" :class="statusBadgeClass(systemInfo.storage_status)">{{ statusText(systemInfo.storage_status) }}</span>
                  </div>
                  <small v-if="systemInfo.storage_used !== null && systemInfo.storage_total !== null" class="text-muted d-block mt-1">
                    {{ $t('about.system.disk_usage', { used: formatBytes(systemInfo.storage_used), total: formatBytes(systemInfo.storage_total) }) }}
                  </small>
                </div>
              </div>
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-time-line text-info mb-2" style="font-size: 2rem;"></i>
                  <h5 class="text-info mb-1">{{ formatUptime(systemInfo.uptime) }}</h5>
                  <small class="text-muted">{{ $t('about.system.uptime') }}</small>
                </div>
              </div>
            </div>
            <table class="table table-sm">
              <tbody>
                <tr>
                  <td class="fw-medium">{{ $t("about.group.system") }}</td>
                  <td>Powered By AICO-Wis Linux 9.0</td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t("system.version") }}</td>
                  <td>{{ systemInfo.version || version }}</td>
                </tr>
                <tr v-if="previewSupported">
                  <td class="fw-medium">{{ $t("about.program.preview_update") }}</td>
                  <td>
                    <div class="form-check form-switch mb-1">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        :checked="allowPreview"
                        :disabled="canTogglePreview !== 1 || previewSaving || loading.versionStatus"
                        @change="toggleAllowPreview"
                      />
                    </div>
                    <small class="text-muted d-block">{{ $t("about.program.preview_update_hint") }}</small>
                  </td>
                </tr>
                <tr v-for="item in programVersionStatus" :key="item.program_name">
                  <td class="fw-medium">{{ getProgramDisplayName(item.program_name) }}</td>
                  <td>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <span>{{ item.local_version || "-" }}</span>
                      <span
                        v-if="runStatusText(item.run_status)"
                        class="badge"
                        :class="runStatusBadgeClass(item.run_status)"
                      >{{ runStatusText(item.run_status) }}</span>
                      <span
                        v-if="item.has_update"
                        class="badge bg-warning text-dark"
                      >{{ $t("about.program.update") }}</span>
                      <span
                        v-else
                        class="badge bg-success"
                      >{{ $t("about.program.latest") }}</span>
                    </div>
                    <small class="text-muted d-block">
                      {{ channelText(item.latest_channel) }} {{ item.latest_version || "-" }} / {{ item.upload_time || "-" }}
                    </small>
                  </td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t('about.system.hostname') }}</td>
                  <td>{{ systemInfo.hostname || $t('about.system.unavailable') }}</td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t('about.system.model') }}</td>
                  <td>{{ systemInfo.model || $t('about.system.unavailable') }}</td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t('about.system.build_date') }}</td>
                  <td>{{ formatBuildTime(buildTime) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 更新日志 -->
      <div class="col-lg-6 col-12 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-header bg-warning text-dark">
            <h6 class="mb-0">
              <i class="ri-file-list-line me-2"></i>
              {{ $t("about.update.text") }}
            </h6>
          </div>
          <div class="card-body">
            <div class="update-log" style="max-height: 400px; overflow-y: auto;">
              <div v-if="updatelog[lang] && updatelog[lang].length > 0">
                <div v-for="(val, idx) in updatelog[lang]" :key="idx" class="mb-3 p-3 border rounded">
                  <div class="d-flex align-items-start">
                    <span class="update-log-index me-2">{{ idx + 1 }}</span>
                    <span class="text-muted">{{ val }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="text-center text-muted py-4">
                <i class="ri-file-list-line mb-2" style="font-size: 3rem;"></i>
                <p>{{ $t('about.update.no_updates') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-4">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-secondary text-white">
            <h6 class="mb-0">
              <i class="ri-folder-chart-line me-2"></i>
              {{ $t('about.storage.title') }}
            </h6>
          </div>
          <div class="card-body" v-loading="loading.storage">
            <div class="row">
              <div class="col-lg-6 col-12 mb-3 mb-lg-0">
                <div class="border rounded p-3 h-100">
                  <div class="d-flex justify-content-between align-items-start gap-2">
                    <div>
                      <div class="text-muted">{{ $t('about.storage.logs') }}</div>
                      <h4 class="mb-1">{{ storageUsage.logs.human || formatBytes(storageUsage.logs.bytes) }}</h4>
                      <small class="text-muted">{{ $t('about.storage.files', { count: storageUsage.logs.files || 0 }) }}</small>
                    </div>
                    <button
                      v-if="storageUsage.can_clear === 1"
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      :disabled="clearing === 'logs'"
                      @click="clearStorage('logs')"
                    >{{ $t('about.storage.clear_logs') }}</button>
                  </div>
                  <ul class="list-unstyled mb-0 mt-3">
                    <li v-for="item in storageUsage.logs.items" :key="item.key" class="d-flex justify-content-between small py-1">
                      <span>{{ storageItemLabel(item.key) }}</span>
                      <span class="text-muted">{{ item.human }} / {{ $t('about.storage.files', { count: item.files }) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="border rounded p-3 h-100">
                  <div class="d-flex justify-content-between align-items-start gap-2">
                    <div>
                      <div class="text-muted">{{ $t('about.storage.cache') }}</div>
                      <h4 class="mb-1">{{ storageUsage.cache.human || formatBytes(storageUsage.cache.bytes) }}</h4>
                      <small class="text-muted">{{ $t('about.storage.files', { count: storageUsage.cache.files || 0 }) }}</small>
                    </div>
                    <button
                      v-if="storageUsage.can_clear === 1"
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      :disabled="clearing === 'cache'"
                      @click="clearStorage('cache')"
                    >{{ $t('about.storage.clear_cache') }}</button>
                  </div>
                  <ul class="list-unstyled mb-0 mt-3">
                    <li v-for="item in storageUsage.cache.items" :key="item.key" class="d-flex justify-content-between small py-1">
                      <span>{{ storageItemLabel(item.key) }}</span>
                      <span class="text-muted">{{ item.human }} / {{ $t('about.storage.files', { count: item.files }) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.company-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.update-log-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.4rem;
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  background-color: #495057;
  border-radius: 0.25rem;
}

.update-log {
  scrollbar-width: thin;
  scrollbar-color: #dee2e6 #f8f9fa;
}

.update-log::-webkit-scrollbar {
  width: 6px;
}

.update-log::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 3px;
}

.update-log::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
}

.update-log::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

@media (max-width: 768px) {
  .border-end {
    border-right: none !important;
    border-bottom: 1px solid #dee2e6 !important;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }
  
  .border-end:last-child {
    border-bottom: none !important;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
</style>